import { I18n } from 'i18n-js'

import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'

import en from '../locales/en.json'
import it from '../locales/it.json'

// Import the translations that come with dayjs (only for our locales)
// > Note: These translations come from the dayjs package,
//   and we are not required to do anything to set them
import 'dayjs/locale/en'
import 'dayjs/locale/it'

const i18n = new I18n({
  ...en,
  ...it,
})

// NOTE: Only English ('en') and Italian ('it') translations are loaded above.
// Turkish ('tr') and Norwegian ('nb') have been removed.
// (i18n-js v4.5.0 removed the `availableLocales` setter; the available locales
//  are now derived from the loaded translations.)
i18n.enableFallback = true

// @ts-expect-error window.locale doesn't exist (according to TypeScript)
const currentLocale = window.locale || 'en'
i18n.locale = currentLocale

// Setup daysjs to handle different locales and set the default locale of dayjs
dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)
// @ts-expect-error window.locale doesn't exist (according to TypeScript)
dayjs.locale(window.locale || 'en')

// @ts-expect-error window.isDevelopment doesn't exist (according to TypeScript)
if (window.isDevelopment) {
  i18n.missingBehavior = 'error'
}

export default i18n
